import { ApolloLink } from '@apollo/client';
import { datadogLogs } from '@datadog/browser-logs';

export const roundTripLink = new ApolloLink((operation, forward) => {
  const start = Date.now();
  operation.setContext({ start });

  return forward(operation).map(data => {
    const end = Date.now();
    const time = end - operation.getContext().start;

    datadogLogs.logger.info('WebGraphQLLatencyMetric', {
      ...operation,
      latency: { start, end, time },
    });
    return data;
  });
});
